/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
// src/themes/theme1/utils/theme1Constants.js
export const ORDER_STATUS = { PENDING: 1 };

export const THEME_NAME_TO_ID = {
  "Classic Brown": 1,
  "Ocean Blue": 2,
  "Royal Purple": 3,
  "Coral Red": 4,
};

export const THEMES = {
  1: { name: "Classic Brown", primary: "#C18064", primaryDark: "#A66B52", background: "#FAF5F3", secondaryBackground: "#FFF9E6" },
  2: { name: "Ocean Blue", primary: "#4A90E2", primaryDark: "#357ABD", background: "#F0F7FF", secondaryBackground: "#E6F2FF" },
  3: { name: "Royal Purple", primary: "#9B59B6", primaryDark: "#8E44AD", background: "#F8F4FB", secondaryBackground: "#F3E8FF" },
  4: { name: "Coral Red", primary: "#E74C3C", primaryDark: "#C0392B", background: "#FFF5F3", secondaryBackground: "#FFE6E3" },
};

export const menuBtnStyle = {
  width: "100%",
  padding: "10px",
  background: "none",
  border: "none",
  textAlign: "right",
  cursor: "pointer",
  borderRadius: "8px"
};
